<!-- Footer -->
<p class="clearfix mb-0">
  <span class="float-md-left d-block d-md-inline-block mt-25">
    Constel/Shop ✨ {{ version }}
    <span class="d-none d-sm-inline-block"> ▪ Copyright &copy; {{ year }}</span>
    <a class="ml-25" href="https://www.constel.cloud" target="_blank">Audax & Solução Sistemas</a>
    <span class="d-none d-sm-inline-block">, todos os direitos reservados</span>
  </span>
  <span class="float-md-right d-none d-md-block">
    Feito com <span [data-feather]="'heart'" [class]="'pink'"></span>
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>